import { render } from "./BeritaDetail.vue?vue&type=template&id=1d35cee2&scoped=true"
import script from "./BeritaDetail.vue?vue&type=script&lang=js"
export * from "./BeritaDetail.vue?vue&type=script&lang=js"

import "./BeritaDetail.vue?vue&type=style&index=0&id=1d35cee2&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d35cee2"]])

export default __exports__